import { ChangeDetectionStrategy, Component, Input, ViewChild } from "@angular/core";
import { DxDataGridComponent } from "devextreme-angular";
import { AdminGridColumnsFactory } from "../admin-grid/admin-grid-columns-factory";
import { AccountViewModel } from "src/app/core/model/ContentManagement";
import { MetadataService } from "src/app/services/metadata.service";
import { map } from "rxjs";
import { Workbook } from "exceljs/dist/exceljs.min.js";
import { exportDataGrid } from "devextreme/excel_exporter";
import { saveAs } from "file-saver";
import { Column, ToolbarPreparingEvent } from "devextreme/ui/data_grid";

@Component({
  selector: "brd-sfaccount-grid",
  templateUrl: "./sfaccount-grid.component.html",
  styleUrl: "./sfaccount-grid.component.less",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SFAccountGridComponent {
  @Input() selectedGroups: string[];
  @Input() exportOptions: {
    enabled: boolean;
    fileName: string;
  };
  @ViewChild(DxDataGridComponent) grid: DxDataGridComponent;
  pageSize = 10;

  columnsGroups = [
    AdminGridColumnsFactory.createTextColumn<AccountViewModel>(
      { fieldName: "accountId", caption: "Id" },
      {
        visible: false
      }
    ),
    AdminGridColumnsFactory.createTextColumn<AccountViewModel>({ fieldName: "accountName", caption: "User Group" }),
    AdminGridColumnsFactory.createTextColumn<AccountViewModel>({ fieldName: "partnerTier", caption: "User Group Type" }),
    AdminGridColumnsFactory.createCheckboxColumn<AccountViewModel>(
      { fieldName: "isBoardGroup", caption: "Board Group" },
      {
        visible: false
      }
    ),
    AdminGridColumnsFactory.createSelectionColumn()
  ];

  sfAccounts$ = this.metadataService.accounts$;

  constructor(private metadataService: MetadataService) {
    this.pageSize = window.innerHeight > 1000 ? 20 : 10;

    this.sfAccounts$ = this.sfAccounts$.pipe(
      map(accounts => {
        const types = [...new Set(accounts.map(account => account.partnerTier))];

        this.columnsGroups = [
          AdminGridColumnsFactory.createTextColumn<AccountViewModel>(
            { fieldName: "accountId", caption: "Id" },
            {
              visible: false
            }
          ),
          AdminGridColumnsFactory.createTextColumn<AccountViewModel>({ fieldName: "accountName", caption: "User Group" }),
          AdminGridColumnsFactory.createLookupColumn<AccountViewModel>({
            fieldName: "partnerTier",
            caption: "User Group Type",
            lookup: { dataSource: types.map(t => ({ id: t ?? "", name: t ?? "-" })) }
          }),
          AdminGridColumnsFactory.createCheckboxColumn<AccountViewModel>(
            { fieldName: "isBoardGroup", caption: "Board Group" },
            {
              visible: false
            }
          ),
          AdminGridColumnsFactory.createSelectionColumn()
        ];

        return accounts;
      })
    );
  }

  onExporting(e): void {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet("Companies");
    exportDataGrid({
      component: e.component,
      worksheet,
      customizeCell: options => {
        const { gridCell, excelCell } = options;
        const visibleColumns = this.columnsGroups.filter((x: Column) => x.dataField && (x.visible || x.visible === undefined)).length;

        // Add selection
        if (gridCell.column.visibleIndex === visibleColumns) {
          if (gridCell.rowType === "data") {
            const isSelected = e.component.isRowSelected(gridCell.data.accountId);
            worksheet.getRow(excelCell.row).values = [...worksheet.getRow(excelCell.row).values.slice(1), isSelected ? "Yes" : "No"];
          } else {
            worksheet.getRow(excelCell.row).values = [...worksheet.getRow(excelCell.row).values.slice(1), "Selected"];
          }
        }
      }
    }).then(() => {
      workbook.xlsx.writeBuffer().then(buffer => {
        saveAs(new Blob([buffer], { type: "application/octet-stream" }), `${this.exportOptions?.fileName ?? "Atuhorization"}.xlsx`);
      });
    });
  }

  onToolbarPreparing(e: ToolbarPreparingEvent): void {
    const exportBtn = e.toolbarOptions.items?.find(x => x.name === "exportButton");
    if (exportBtn) exportBtn.location = "before";
  }
}
